module.exports = __webpack_public_path__ + "static/img/core-illustration-eng.4fab6fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/core-illustration-eng.png
// module id = fzuy
// module chunks = 0